import { makeStyles, tokens } from "@fluentui/react-components";
import React from "react";
import { $gray600 } from "../../../../cssjs/colors";
import { formatDisplayValue } from "../../../../utils/common/FormatHelper";

export interface IFlightMarkerTooltipProps {
  flightNumber: string;
  airportCode: string;
  legType: string;
  acType?: string;
  acReg?: string;
  onBlockTime?: string;
  offBlockTime?: string;
}

const FlightMarkerTooltip: React.FC<IFlightMarkerTooltipProps> = ({
  flightNumber,
  airportCode,
  legType,
  acType,
  acReg,
}) => {
  const classes = useStyles();

  const tooltipContent =
    legType === "arrival" ? "Arriving at" : "Departed from";

  return (
    <article
      className={classes.tooltipContent}
      data-testid="flight-marker-tooltip"
    >
      <span className={classes.tooltipLabel}>Flight No</span>
      <strong className={classes.tooltipValue}>{flightNumber}</strong>

      <span className={classes.tooltipLabel}>{tooltipContent}</span>
      <span className={classes.tooltipValue}>{airportCode}</span>

      <span className={classes.tooltipLabel}>A/C Type</span>
      <span className={classes.tooltipValue}>{formatDisplayValue(acType)}</span>

      <span className={classes.tooltipLabel}>A/C Reg</span>
      <span className={classes.tooltipValue}>{formatDisplayValue(acReg)}</span>
    </article>
  );
};

export default FlightMarkerTooltip;

const useStyles = makeStyles({
  tooltipContent: {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    rowGap: tokens.spacingVerticalS,
    columnGap: tokens.spacingVerticalL,
    padding: "4px",
    width: "max-content",
    minWidth: "100px",
    maxWidth: "200px",
    fontSize: "12px",
    alignItems: "center",
    fontWeight: 500,
  },
  tooltipLabel: {
    color: $gray600,
  },
  tooltipValue: {
    textAlign: "left",
  },
});
